export const interestIsRemoved = (
  id:string | undefined,
  status: string | undefined,
  removedList: string[],
) : boolean => {
  const removedThisSession = id && removedList.includes(id);
  return removedThisSession || status === "Removed";
};

export const formatMoney = (value: number): string => `$${value.toFixed(2).replace(/\d(?=(?:\d{3})+(?:\.\d{2})?$)/g, "$&,")}`;

export const moneyToFloat = (value: string): number => parseFloat(value.replace(/[^0-9.-]+/g, ""));

// Function to convert and format money value based on conversion type
export const convertAndFormatMoney = (value: string, conversionType: "monthly" | "yearly"): string => {
  // Removing the currency symbol and any commas, then converting to a float
  const numberValue = moneyToFloat(value);
  const convertedValue = conversionType === "monthly" ? numberValue * 12 : numberValue;

  // Format the converted number as money
  return formatMoney(convertedValue);
};
